import type { ReactElement } from 'react';
import { Alert, Space, Tag, Typography } from 'antd';

import type { QuoteWarningOut } from '../types';

interface QuoteWarningsPanelProps {
  warnings: QuoteWarningOut[];
}

const severityColor: Record<QuoteWarningOut['severity'], string> = {
  info: 'blue',
  warning: 'gold',
  error: 'red',
};

export const QuoteWarningsPanel = ({ warnings }: QuoteWarningsPanelProps): ReactElement | null => {
  if (!warnings.length) return null;
  const hasErrors = warnings.some((warning) => warning.severity === 'error');
  return (
    <Alert
      type={hasErrors ? 'error' : 'warning'}
      showIcon
      className="quote-warnings-panel"
      message="Advertencias del presupuesto"
      description={(
        <Space direction="vertical" size={6} style={{ width: '100%' }}>
          {warnings.map((warning) => (
            <div key={`${warning.code}-${warning.line_key ?? warning.item_id ?? warning.message}`} className="quote-warnings-panel__item">
              <Tag color={severityColor[warning.severity]}>{warning.severity.toUpperCase()}</Tag>
              <Typography.Text>{warning.message}</Typography.Text>
            </div>
          ))}
        </Space>
      )}
    />
  );
};

export default QuoteWarningsPanel;
